import { render, staticRenderFns } from "./ViewSalaryCard.vue?vue&type=template&id=51d244a0"
import script from "./ViewSalaryCard.vue?vue&type=script&lang=js"
export * from "./ViewSalaryCard.vue?vue&type=script&lang=js"
import style0 from "./ViewSalaryCard.vue?vue&type=style&index=0&id=51d244a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports